import '../../../../utils/index.mjs';
import { buildProps } from '../../../../utils/vue/props/runtime.mjs';

const paginationTotalProps = buildProps({
  total: {
    type: Number,
    default: 1e3
  }
});

export { paginationTotalProps };
//# sourceMappingURL=total2.mjs.map
